var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLudos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 42,
    viewBox: "0 0 36 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_80_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9177 3.59911C4.37934 5.24932 5.63918 15.8198 7.83552 20.8925C13.178 25.3889 24.7888 31.511 28.493 20.0282C33.1231 5.67462 20.6714 4.45868 20.4793 3.94528C20.3416 3.57735 23.5067 4.46409 23.8628 3.94528C24.5751 3.42648 24.3615 0.867056 22.082 1.0054C19.8025 1.14375 18.8765 2.73475 18.5204 3.25355C18.461 3.36874 18.6984 2.73475 18.5204 1.87008C18.2236 1.52411 17.6299 1.35127 16.9177 1.69714C16.0272 2.21594 17.2738 3.55225 16.9177 3.59911Z",
    fill: "#F8E370",
    stroke: "#5F3713",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0829 11.3764C19.9596 -0.936526 12.9896 5.93687 10.3777 10.6061H10.7339C12.5741 10.1449 15.038 7.05303 17.1102 9.81997C18.5349 11.7222 18.2133 15.1024 18.2133 16.4858C18.2133 17.8693 14.8298 19.5987 13.049 19.2528C11.2681 18.9069 10.0216 16.6588 9.13115 17.0046C8.41882 17.2813 9.6654 18.8493 10.3777 19.5987L13.7613 20.8092L15.364 19.5987L18.2133 19.2528L19.9942 20.8092L22.1312 19.2528L23.912 19.9445L22.1312 18.2152C19.9942 14.5836 20.6719 11.7222 22.1312 10.6061C24.6661 8.66715 28.1514 13.2233 27.0829 11.3764Z",
    fill: "#FFF496"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35616 22.617L5 17.7748L8.56164 18.8124L9.9863 17.256L14.0822 19.3312L15.5068 17.256L18.5342 16.9102L20.6712 18.8124L23.1644 17.256L27.7945 19.85L31 17.7748L30.6438 21.7523C30.169 25.4992 27.2959 33.2697 18.1781 32.993C9.06027 32.7163 5.89041 26.0757 5.35616 22.617Z",
    fill: "#FAFAFA",
    stroke: "#5F3713",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0544 13.7168C11.0544 10.5684 15.8028 7.27695 17.3855 13.5737C18.3003 17.2127 11.0544 16.9387 11.0544 13.7168Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7402 14.2351C21.7402 10.9042 26.3199 9.23871 27.0526 13.9323C27.549 17.1118 21.7402 17.6438 21.7402 14.2351Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6026 14.163C19.1153 14.0053 18.1779 14.8223 17.8218 15.2258C18.8309 16.2058 21.6785 16.5727 20.6711 15.3987C19.7807 14.3611 20.1368 14.336 19.6026 14.163Z",
    fill: "#F39854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9849 16.4298C17.7409 16.2447 17.6528 15.5028 17.8212 15.1802C18.7632 15.3278 20.8513 16.6404 19.7801 16.5637C18.8333 16.4959 18.2525 16.6328 17.9849 16.4298Z",
    fill: "#F39854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3434 11.0382C12.5679 11.0382 12.124 12.6461 12.124 13.4501C12.2947 14.1966 13.0118 15.6553 14.5141 15.5174C16.0165 15.3796 16.3921 14.0818 16.3921 13.4501C16.449 12.5887 16.1189 10.9004 14.3434 11.0382Z",
    fill: "#5F3713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3026 12.4197C22.823 12.4197 22.4531 13.6566 22.4531 14.275C22.5954 14.8492 23.1929 15.9713 24.4449 15.8652C25.6969 15.7592 26.0098 14.7609 26.0098 14.275C26.0573 13.6124 25.7822 12.3137 24.3026 12.4197Z",
    fill: "#5F3713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5469 12.7571C13.5469 12.2057 13.903 12.0679 14.0811 12.0679C14.1998 12.1253 14.4729 12.3436 14.6154 12.7571C14.6154 12.9294 13.5469 13.4464 13.5469 12.7571Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5198 13.9107C23.5198 13.5431 23.7572 13.4512 23.8759 13.4512C23.9551 13.4895 24.1371 13.635 24.2321 13.9107C24.2321 14.0256 23.5198 14.3702 23.5198 13.9107Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1065 18.5069C13.7686 16.21 10.3667 16.7775 10.3667 17.8151C10.1887 19.5445 11.0078 20.3054 11.4352 20.5821C11.9695 20.9279 14.2845 19.7174 14.1065 18.5069Z",
    fill: "#F8E471",
    stroke: "#32170B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.749 18.5069C22.0869 16.21 25.4887 16.7775 25.4887 17.8151C25.6668 19.5445 24.8476 20.3054 24.4202 20.5821C23.886 20.9279 21.5709 19.7174 21.749 18.5069Z",
    fill: "#F8E471",
    stroke: "#32170B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_80_2",
    x: 0.724365,
    y: 0.75,
    width: 34.5703,
    height: 40.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_80_2",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLudos);
export default __webpack_public_path__ + "static/media/Ludos.dc9f135bc80b38de2afddc59a221d3e7.svg";
export { ForwardRef as ReactComponent };